interface ServiceTypeStatusConfirmModalProps {
  mode: "activate" | "deactivate";
  serviceTypeName: string;
  onCancel: () => void;
  onConfirm: () => void;
  isProcessing?: boolean;
}

export const ServiceTypeStatusConfirmModal: React.FC<ServiceTypeStatusConfirmModalProps> = ({
  mode,
  serviceTypeName,
  onCancel,
  onConfirm,
  isProcessing = false,
}) => {
  const isDeactivate = mode === "deactivate";
  const title = isDeactivate ? "Ngưng hoạt động" : "Kích hoạt hoạt động";
  const description = isDeactivate
    ? `Bạn có chắc chắn muốn ngưng hoạt động dịch vụ "${serviceTypeName}"?`
    : `Bạn có chắc chắn muốn chuyển dịch vụ "${serviceTypeName}" sang trạng thái đang hoạt động?`;
  const confirmLabel = isDeactivate ? "Ngưng ngay" : "Kích hoạt";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-2xl">
        <h3 className="text-xl font-semibold text-slate-800">{title}</h3>
        <p className="mt-3 text-sm text-slate-600">{description}</p>

        <div className="mt-6 flex justify-end gap-3">
          <button
            type="button"
            onClick={onCancel}
            disabled={isProcessing}
            className="inline-flex min-w-[100px] items-center justify-center rounded-full border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-600 transition hover:border-slate-300 hover:text-slate-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Hủy
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isProcessing}
            className={`inline-flex min-w-[120px] items-center justify-center rounded-full px-4 py-2 text-sm font-semibold text-white shadow transition disabled:cursor-not-allowed disabled:opacity-60 ${
              isDeactivate ? "bg-amber-500 hover:bg-amber-600" : "bg-emerald-500 hover:bg-emerald-600"
            }`}
          >
            {isProcessing ? "Đang xử lý..." : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceTypeStatusConfirmModal;
